import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreAlarmLogsReportWizardFilters',
  props: {
    reportModel: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      editModel: null,
      smartGroupsFinishedLoading: false,
      smartGroupList: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    operationalStatusTexts() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatuses() {
      return Object.keys(this.operationalStatusTexts).map(os => {
        return {
          text: this.operationalStatusTexts[os],
          value: os
        };
      });
    },
    operationalStatusValue: {
      get() {
        const value = this.editModel.filters.operationalStatus;
        return value === null || value === undefined ? value : String(value);
      },
      set(value) {
        this.editModel.filters.operationalStatus = value;
      }
    },
    logCategories() {
      return [this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'battery',
        text: this.$i18n_t('AlarmLogs.categories.battery')
      } : null, this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'connectivity',
        text: this.$i18n_t('AlarmLogs.categories.connectivity')
      } : null, this.editModel.filters.originType === 'virtual-device--health-state' ? {
        value: 'device',
        text: this.$i18n_t('AlarmLogs.categories.device')
      } : null, this.editModel.filters.originType !== 'virtual-device--health-state' ? {
        value: 'packet-threshold',
        text: this.$i18n_t('AlarmLogs.categories.packet-threshold')
      } : null].filter(c => c);
    },
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    }
  },
  watch: {
    reportModel: {
      handler: function () {
        this.editModel = cloneDeep(this.reportModel);
      },
      deep: true,
      immediate: true
    },
    'editModel.tenantId': {
      handler: function () {
        this.fetchSmartGroups();
      },
      immediate: true
    },
    editModel: {
      handler: function () {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.reportModel)) {
          this.publishChanges();
        }
      },
      deep: true
    }
  },
  methods: {
    fetchSmartGroups() {
      if (!get(this.editModel, 'tenantId')) {
        return;
      }
      this.smartGroupsFinishedLoading = false;
      // fetch groups filtered by the chosen account from step 1
      ApiService.virtualDeviceViewsFetch(this, {
        tenantIds: [this.editModel.tenantId]
      }).then(response => {
        this.smartGroupList = response;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.loadMonitoringViewFailed'), 'error');
      }).finally(() => {
        this.smartGroupsFinishedLoading = true;
      });
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};